(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function lockScroll(form) {
    var savedY = window.scrollY;
    document.documentElement.classList.add('no-smooth-scroll');

    var target = form.closest('.email-signup-block') || document.body;
    var observer = new MutationObserver(function () {
      observer.disconnect();
      // 强制恢复滚动位置，使用 instant 避免任何动画
      window.scrollTo({ top: savedY, behavior: 'instant' });
      // 短暂延迟后移除 class，确保浏览器已完成渲染
      requestAnimationFrame(function () {
        document.documentElement.classList.remove('no-smooth-scroll');
      });
    });

    observer.observe(target, { childList: true, subtree: true });

    // 兜底：600ms 后强制清理
    setTimeout(function () {
      observer.disconnect();
      window.scrollTo({ top: savedY, behavior: 'instant' });
      document.documentElement.classList.remove('no-smooth-scroll');
    }, 600);
  }

  // 使用事件委托，兼容 morph 后重新渲染的表单
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.classList.contains('email-signup__form')) {
      lockScroll(e.target);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
